module.exports = __webpack_public_path__ + "img/sideflag.0c15d7e.png";